import { SURE_CARE_NAME } from 'core/constants/products'
import getCorrespondingPolicy from 'core/services/getPlansByProductId/getCorrespondingPolicy'
import getAndValidatePeriod from 'utils/pivot/plan/getAndValidateDuration'

const sortByMonthly = (predicate, plans, period, a, b) => {
  if (period instanceof Array) {
    return predicate(
      getCorrespondingPolicy({ plan: plans[a], additionalPeriods: period }).monthly
        .premium,
      getCorrespondingPolicy({ plan: plans[b], additionalPeriods: period }).monthly
        .premium
    )
  } else {
    // If there is a SureCare plan, just use its first duration for sorting
    // This is because, in VA, there won't always be a result for getAndValidatePeriod(...)[1]
    return predicate(
      plans[a].type === SURE_CARE_NAME
        ? plans[a].durationsArray[0].monthly.premium
        : getAndValidatePeriod(plans[a], period)[1].monthly.premium,
      plans[b].type === SURE_CARE_NAME
        ? plans[b].durationsArray[0].monthly.premium
        : getAndValidatePeriod(plans[b], period)[1].monthly.premium
    )
  }
}

export default sortByMonthly
